@if (Intervention) {
<div class="container-fluid">
    <div class="row">
        <h2 class="col text-center fw-bold"> {{Intervention.SamplingPoint.Name}}</h2>
    </div>
    <div class="row">
        <span class="col text-center"> Intervention {{Intervention.Code}} </span>
    </div>
    <div class="row">
        <span class="col text-center"> Stratégie {{Intervention.Strategy.Id}} </span>
    </div>
    <div class="row">
        <span class="my-2 col text-center"> {{Intervention.SamplingPoint.Address}} {{Intervention.SamplingPoint.ZipCode}} {{Intervention.SamplingPoint.City}}</span>
    </div>
    <div class="row">
        <span class="my-2 col text-center"> {{Intervention.SamplingPoint.ClientName}} {{Intervention?.Contact ? '-': ''}} {{Intervention?.Contact?.FirstName}}
            {{Intervention?.Contact?.LastName}}
            {{Intervention?.Contact?.Phone}}</span>
    </div>
    @if (Intervention?.Comment && Intervention?.Comment != '') {
    <div class="row">
        <span class="my-2 col text-center"> {{Intervention.Comment}}</span>
    </div>
    }
    @if (Intervention.RequiresMasqueAdduction) {
    <div class="row align-items-center justify-content-center">
        <div class="col-auto">
            <mat-icon color="warn" class="material-symbols-outlined">warning</mat-icon>
        </div>
        <h3 class="col-auto fst-italic fw-bold blink-one" style="color: red;">Masque à adduction d'air à prévoir</h3>
        <div class="col-auto">
            <mat-icon color="warn" class="material-symbols-outlined">warning</mat-icon>
        </div>
    </div>
    }
    @if (IsDispatch) {
    <div class="row justify-content-center align-items-center my-1">
        <div class="col-auto">
            <button color="primary" mat-raised-button (click)="navigateToDemetra()">
                Aller vers Demetra <mat-icon class="material-symbols-outlined">assistant_direction</mat-icon>
            </button>
        </div>

        <div class="col-auto">
            <button color="accent" mat-raised-button (click)="resetCodage()">
                <mat-icon class="material-symbols-outlined">replay</mat-icon> Relancer le codage
            </button>
        </div>

        @if (Intervention.ElimsJob.HasError) {
        <div class="col-auto">
            <mat-icon color="warn" class="material-symbols-outlined">cancel</mat-icon>
        </div>
        <div class="col-auto">
            {{getSequenceLevelError(Intervention.ElimsJob.Status)}}
        </div>
        }
        @if (Intervention.ElimsJob.IsPending) {
        <div class="col-auto">
            <mat-icon class="material-symbols-outlined">hourglass_empty</mat-icon>
            <div></div>
        </div>
        }
        @if (Intervention.ElimsJob.Status === EElimsAggregatedStatus.AllJobsCompleted) {
        <div class="col-auto">
            <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
            <div></div>
        </div>
        }
    </div>

    }
    @if (Intervention.ElimsJob.HasError) {
    <div class="row justify-content-center mb-3">
        <div class="col-auto" style="font-size: large; color: red;">
            {{Intervention.ElimsJob.LastError}}
        </div>
    </div>
    }
    <div class="row justify-content-around">
        @for (p of Intervention.ProcessList; track p) {
        <div class="col-12 col-sm-6 col-xl-4 text-center">
            <div class="m-1 p-3 border rounded-1 background-light">
                <div class="row align-items-center justify-content-around">
                    <div class="col-2"></div>
                    <div class="col fw-bold">{{p.Name}} {{p.CustomerReference}}</div>
                    <div class="col-2">
                        <button class="" color="primary" mat-icon-button (click)="openChangeProcessBox(p.ProcessMesure.SamplingId)">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="row justify-content-center align-items-center">
                    <div class="col border rounded-1 m-1 p-2" [style.background]="p.ProcessMesure.Color">
                        <div class="fs-5 fw-bold" [style.color]="p.ProcessMesure.TextColor" [matTooltip]="p.AreaMap?.Legend ? p.AreaMap.Legend : ''"
                            (click)="openChangeLetterBox(p.ProcessMesure.SamplingId, true)">
                            {{p.ProcessMesure.MeasureReferenceName}}
                        </div>
                    </div>
                    <div class="col">
                        <span>
                            {{p.ProcessMesure?.SampleCode}}
                        </span>
                    </div>
                    <div class="col-2">
                        @if (IsTechnicien) {
                        <button class="col-auto" color="primary" mat-icon-button (click)="openChangeMapBox(p.ProcessMesure.SamplingId)">
                            <mat-icon class="material-symbols-outlined">map_search</mat-icon>
                        </button>
                        }
                    </div>
                </div>
                @if (IsDispatch || IsValideur) {
                <div class="row">
                    <div class="col-2"></div>
                    <div class="col fw-bold"></div>
                    <div class="col-2">
                        <button class="col-auto" color="primary" mat-icon-button (click)="editMap(p.AreaMap.Id)">
                            <mat-icon class="material-symbols-outlined">map</mat-icon>
                        </button>
                    </div>
                </div>
                }
            </div>
        </div>
        }
        @for (z of Intervention.ZoneList; track z) {
        <div class="col-12 col-sm-6 col-xl-4 text-center">
            <div class="m-1 p-3 border rounded-1 background-light">
                <div class="row ">
                    <div class="fw-bold text-start" [style.color]="z.IsDepose ? 'slateblue' : 'cadetblue'">{{z.IsDepose ? "DEPOSE": "POSE"}}</div>
                </div>
                <div class="row align-items-center justify-content-around">
                    <div class="col-2"></div>
                    <div class="col fw-bold">Zone {{z.Name}} @if (z.CustomerReference) {
                        <span>({{z.CustomerReference}})</span>
                        }
                    </div>
                    <div class="col-2">
                        @if (IsDispatch || IsTechnicien) {
                        <button class="" color="primary" mat-icon-button (click)="openChangeZoneBox(z)">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        </button>
                        }
                    </div>
                </div>

                @for (zm of z.ZoneMesureList; track zm) {
                <span>
                    <div class="row justify-content-center">
                        <div class="border rounded-1 col m-1 p-2" (click)="openChangeLetterBox(zm.SamplingId, false)" [style.background]="zm.Color">
                            <div class="fs-5 fw-bold" [style.color]="zm.TextColor">
                                {{zm.MeasureReferenceName}}
                            </div>
                        </div>
                        <div class="col">
                            <span>
                                {{zm?.SampleCode}}
                            </span>
                        </div>
                    </div>
                </span>
                }
                @if (IsDispatch || IsValideur) {
                @for (am of z.AreaMapList; track am) {
                <div class="row align-items-center">
                    <div class="col-2"></div>
                    <div class="col fw-bold">{{am.Legend}}</div>
                    <div class="col-2">
                        <button class="col-auto" color="primary" mat-icon-button (click)="editMap(am.Id)">
                            <mat-icon class="material-symbols-outlined">map</mat-icon>
                        </button>
                    </div>
                </div>
                }
                }
                @if (IsDispatch && z.IsDepose) {
                <div class="row mt-3">
                    <mat-form-field class="col">
                        <input matInput placeholder="Début" [matDatepicker]="picker1" [(ngModel)]="Date" (focus)="picker1.open()">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <div class="col-auto">
                        <button class="h-75" color="primary" mat-raised-button (click)="moveDepose(z.Code)">
                            Replanifier<mat-icon class="material-symbols-outlined">edit_calendar</mat-icon>
                        </button>
                    </div>
                </div>
                }
            </div>

        </div>
        }
    </div>
    <div class="row">
        @for (mL of Intervention.MesureAdductionAirList; track mL) {
        <div class="col-6 col-sm-4 col-xl-2 p-0">
            <div class="m-1 p-1 border rounded-1 background-light">
                <div class="my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">air</mat-icon>
                </div>
                <div class="text-center">
                    {{mL?.SampleCode}}
                </div>
            </div>
        </div>
        }
        @for (mL of Intervention.MesureMassifList; track mL) {
        <div class="col-6 col-sm-4 col-xl-2 p-0">
            <div class="m-1 p-1 border rounded-1 background-light">
                <div class="my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">biotech</mat-icon>
                </div>
                <div class="text-center">
                    {{mL?.SampleCode}}
                </div>
            </div>
        </div>
        }
        @for (mL of Intervention.MesureEauList; track mL) {
        <div class="col-6 col-sm-4 col-xl-2 p-0">
            <div class="m-1 p-1 border rounded-1 background-light">
                <div class="my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">water</mat-icon>
                </div>
                <div class="text-center">
                    {{mL?.SampleCode}}
                </div>
            </div>
        </div>
        }
        @for (mL of Intervention.MesureLingetteList; track mL) {
        <div class="col-6 col-sm-4 col-xl-2 p-0">
            <div class="m-1 p-1 border rounded-1 background-light ">
                <div class=" my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">wash</mat-icon>
                </div>
                <div class="text-center">
                    {{mL?.SampleCode}}
                </div>
            </div>
        </div>
        }
        @for (g of Intervention.MesureGeneriqueList; track g) {
        <div class="col-6 col-sm-4 col-xl-2 p-0">
            <div class="m-1 p-1 border rounded-1 background-light ">
                <div class=" my-auto col text-center">
                    <mat-icon class="material-symbols-outlined">view_in_ar</mat-icon>
                </div>
                <div class="text-center">
                    {{g?.Name}}
                </div>
            </div>
        </div>
        }
        @if (IsTechnicien) {
        <div class="col-6 col-sm-4 col-xl-2 p-0">
            <div class="row m-1 p-1 border rounded-1 background-light justify-content-center">
                <button class="col-auto" color="primary" mat-fab (click)="openExoticCreationBox()">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                </button>
            </div>
        </div>
        }
    </div>
</div>
}